import SynapseStatusPage from "./SynapseStatusPage";
import { REP_ASSIST_HELP_EMAIL } from "../utils/constantFiles/constant";

function NoAccessPage() {
  return (
    <SynapseStatusPage
      variant="noAccess"
      heading="You don't have access"
      linkHref={`mailto:${REP_ASSIST_HELP_EMAIL}`}
      linkText={REP_ASSIST_HELP_EMAIL}
      linkSuffix="to request access to this application."
    />
  );
}

export default NoAccessPage;
